function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import { AdBreakType } from '../../addons/adverts/common';
var AD_OFFSET = 0.5;
var AdPolicyBase = /*#__PURE__*/ function() {
    "use strict";
    function AdPolicyBase() {
        _class_call_check(this, AdPolicyBase);
    }
    _create_class(AdPolicyBase, [
        {
            key: "shouldPlayAdBreak",
            value: function shouldPlayAdBreak(adBreak, position, isResumingFromBookmark) {
                if (!adBreak.watched && adBreak.type === AdBreakType.Preroll && !isResumingFromBookmark) {
                    return true;
                }
                var adBreakIsAfterPosition = +adBreak.position >= position;
                return !adBreak.watched && (adBreakIsAfterPosition || this.isAdBreakInRange(adBreak, position));
            }
        },
        {
            key: "getAdBreakToPlayBySkippedAdBreaks",
            value: function getAdBreakToPlayBySkippedAdBreaks(skipped) {
                // Yospace ad break don't have an id currently, this fix is in place until this issue is addressed.
                var unwatched = skipped.filter(function(adBreak) {
                    return !adBreak.watched || adBreak.id === null;
                });
                if (unwatched.length >= 1) {
                    return unwatched[unwatched.length - 1];
                }
                return null;
            }
        },
        {
            key: "canPlayAdBreak",
            value: function canPlayAdBreak() {
                return true;
            }
        },
        {
            key: "canAdSkipCatchup",
            value: function canAdSkipCatchup() {
                return true;
            }
        },
        {
            key: "getMinimumSeekablePositionAfterPreroll",
            value: function getMinimumSeekablePositionAfterPreroll(adBreaks) {
                var preRoll = adBreaks.find(function(ab) {
                    return ab.type === AdBreakType.Preroll;
                });
                if (preRoll) {
                    // return time after pre-roll
                    return preRoll.expectedDuration + AD_OFFSET;
                }
                return 0;
            }
        },
        {
            key: "notifyPositionChanged",
            value: function notifyPositionChanged(position) {}
        },
        {
            key: "notifySeeked",
            value: function notifySeeked(position) {}
        },
        {
            key: "notifySeekStarted",
            value: function notifySeekStarted() {}
        },
        {
            key: "notifySeekEnded",
            value: function notifySeekEnded() {}
        },
        {
            key: "notifyAdBreakEnded",
            value: function notifyAdBreakEnded(adBreak) {}
        },
        {
            key: "notifyAdBreakStarted",
            value: function notifyAdBreakStarted(adBreak) {}
        },
        {
            key: "notifyAdBreakDataChanged",
            value: function notifyAdBreakDataChanged(adBreak) {}
        },
        {
            key: "isAdBreakInRange",
            value: function isAdBreakInRange(adBreak, position) {
                var distance = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
                var lowerBound = position - distance;
                var upperBound = position + distance;
                return +adBreak.position >= lowerBound && +adBreak.position <= upperBound;
            }
        }
    ]);
    return AdPolicyBase;
}();
export { AdPolicyBase as default };

//# sourceMappingURL=ad-policy-base.js.map